"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useApiData = useApiData;
var _react = require("react");
var _RequestStatus = _interopRequireDefault(require("../constants/RequestStatus"));
var _RequestApiType = _interopRequireDefault(require("../constants/RequestApiType"));
var _domainServices = require("@site/domain-services");
function useApiData(requestApiType, spinsOptions, apm, onSuccessApiData) {
  const [spinsData, setSpinsData] = (0, _react.useState)(null);
  const [requestStatus, setRequestStatus] = (0, _react.useState)(_RequestStatus.default.LOADING);
  (0, _react.useEffect)(() => {
    const getApiData = () => {
      // eslint-disable-next-line default-case
      switch (requestApiType) {
        case _RequestApiType.default.MERCH_RECOMMEND_API:
          return (0, _domainServices.getMerchRecommendPromise)(spinsOptions, apm);
        case _RequestApiType.default.SPINS_API:
          return (0, _domainServices.getSpinsPromise)(spinsOptions, spinsOptions?.resellerBaseOverride, apm);
      }
    };
    const successCallback = data => {
      setSpinsData(data);
      onSuccessApiData?.(data);
      setRequestStatus(_RequestStatus.default.SUCCESS);
    };
    const errorCallback = () => {
      setRequestStatus(_RequestStatus.default.FAIL);
    };
    if (requestApiType) {
      getApiData()?.then(({
        data
      }) => successCallback(data))?.catch(error => errorCallback(error));
    }
  }, [requestApiType]);
  return {
    spinsData,
    requestStatus
  };
}